import createOrDuplicateProject from '$src/api/endpoints/projects/createOrDuplicateProject'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './CreateProjectModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import DateInput from '$src/common/DateInput'
import DropZone from 'react-dropzone'
import {getSnapshot} from 'mobx-state-tree'
import moment from 'moment'
import {getUsers} from './EditProjectModal'
import MultiSelectInput from '$src/common/MultiSelectInput'

interface Props {
  onRequestClose: Function
  duplicateFrom?: number
  onUpdateNeeded: Function
}

export const makeFile = (
  f: any,
): Promise<{fileFormat: string; fileContentInBase64: string}> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      resolve({
        fileFormat: f.name.match(/\.([^\.]+)$/)[1],
        fileContentInBase64: reader.result.replace(/^[^\,]+\,/, ''),
      })
    }

    reader.readAsDataURL(f)
  })
}

@observer
export default class CreateProjectModal extends Component<
  Props,
  {error?: string; file?: any; submitting: boolean}
> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, file: undefined, submitting: false}
  }

  onDrop = (files: any) => {
    this.setState({file: files[0]})
  }

  onSubmit = async (fields: any) => {
    this.setState({error: undefined})
    if (!this.props.duplicateFrom && !this.state.file) {
      this.setState({error: 'The excel file is also required'})
      return
    }
    if (!fields.name) {
      this.setState({error: 'Choose a name for your project'})
      return
    }
    if (!fields.evaluationDate) {
      this.setState({error: 'Choose an evaluation date for your project'})
      return
    }

    this.setState({submitting: true})

    const excelFile = this.state.file && (await makeFile(this.state.file))

    try {
      const params: any = {
        name: fields.name,
        evaluationDate: fields.evaluationDate.unix() * 1000,
        excelFile,
        customer: fields.customer || '',
        usersInvolved: fields.usersInvolved || [],
      }
      if (this.props.duplicateFrom)
        params.duplicateFrom = this.props.duplicateFrom

      await this.callEndpoint(createOrDuplicateProject, params)

      this.setState({submitting: false})
      this.props.onUpdateNeeded()
      this.props.onRequestClose()
    } catch (error) {
      this.setState(s => ({
        ...s,
        error: error.message || 'Unauthorized',
        submitting: false,
      }))
    }
  }

  render() {
    const {props} = this
    const classes = resolveCss(css)
    let initialValues = undefined
    const users = getUsers(this.store)

    if (props.duplicateFrom) {
      const projectData = getSnapshot(
        // @ts-ignore
        this.store.projects.baseProjectsById.get(props.duplicateFrom),
      )
      initialValues = {
        name: projectData.name,
        evaluationDate: moment(projectData.evaluationDate),
        usersInvolved: projectData.usersInvolved || [],
        customer: projectData.customer || '',
      }
    } else {
      initialValues = {usersInvolved: [this.store.auth.getMyId()]}
    }

    return (
      <GenericModal
        onHide={props.onRequestClose}
        css={{box: {container: css.box}}}
      >
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field
            name="name"
            type="text"
            label="NAME"
            placeholder="Name of the project"
          />
          <TextInput.Field
            name="customer"
            type="text"
            label="CLIENT"
            placeholder="Client"
          />
          <DateInput.Field name="evaluationDate" label="DATE OF EVALUATION" />
          <MultiSelectInput.Field
            style="big"
            label="USERS INVOLVED"
            name="usersInvolved"
            options={users}
          />
          <div className={css.bottom}>
            <div className={css.templates}>
              <GenericButton
                variant="link"
                type="button"
                onClick={
                  () => window.open('/project_template.xlsx', '_blank')
                  // window.open(
                  //   process.env.REACT_APP_BACKEND_BASE_URL +
                  //     '/project-excel-template',
                  //   '_blank',
                  // )
                }
              >
                Download the Excel template
              </GenericButton>
              <GenericButton
                variant="link"
                type="button"
                onClick={
                  () => window.open('/project_template.csv', '_blank')
                  // window.open(process.env.REACT_APP_BACKEND_BASE_URL + '/project-excel-template', '_blank')
                }
              >
                Download the CSV template
              </GenericButton>
            </div>
            <DropZone
              onDrop={this.onDrop}
              className={css.dropZone}
              multiple={false}
              activeClassName={css.dropZoneActive}
            >
              {this.state.file
                ? this.state.file.name
                : 'Drag your excel file here'}
            </DropZone>
            {this.state.error && (
              <div className={css.error}>{this.state.error}</div>
            )}
            <GenericButton
              variant="bold"
              type="submit"
              disabled={this.state.submitting}
            >
              {props.duplicateFrom ? 'DUPLICATE PROJECT' : 'CREATE PROJECT'}
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/CreateProjectModal.tsx